import { onboardingRequestDetailApi } from '../api/OnboardingRequestDetailApi'
import {
  IExecuteAPLTransition,
  onboardingTransitionApi,
} from '../classes/services/api/OnboardingTransitionApi'

class ActionTransitionService {
  public fetchActionTransitions = (requestId: string) => {
    return onboardingRequestDetailApi.getRequestActionTransitions(+requestId)
  }

  public executeTransitionByToken() {
    return onboardingTransitionApi.executeTransitionByToken()
  }

  public executeAplTransition<T>(payload: IExecuteAPLTransition<T>) {
    return onboardingTransitionApi.executeAplTransition<T>(payload)
  }
}

export const actionTransitionService = new ActionTransitionService()
